<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="row justify-content-between">
          <!-- Partner -->
          <div class="repeater_wrapper mt-6">
            <h5>أرسال رسالة للمشتركين</h5>
            <div class="row justify-content-between">
              <!-- ********** Row Data ********** -->
              <div class="col-lg-6">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.title"
                  />
                  <label for="name_input" class="form-label"
                    >عنوان الرسالة</label
                  >
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input_wrapper top_label mx-auto">
                  <input
                    type="url"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.route"
                  />
                  <label for="name_input" class="form-label">الرابط </label>
                </div>
              </div>
              <div class="col-lg-6 mx-auto">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.link"
                  />
                  <label for="name_input" class="form-label">اسم الرابط </label>
                </div>
              </div>

              <div class="input_wrapper top_label col-lg-7 mx-auto">
                <label for="name_input" class="form-label"
                  >محتوي الرسالة
                </label>
                <textarea
                  class="form-control"
                  rows="5"
                  v-model="data.body"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons_wrapper">
          <button class="base-btn">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.subscribe.title"),
          disabled: false,
          href: "/subscribe",
        },
        {
          text: this.$t("breadcrumb.subscribe.send"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== Data
      data: {
        title: null,
        link: null,
        body: null,
        route: null,
      },
    };
  },

  methods: {
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      if (!this.data.title) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل عنوان الرسالة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.body) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل   محتوي الرسالة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.route) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل  الرابط ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.link) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل  اسم الرابط",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();

      submit_data.append("title", this.data.title);
      submit_data.append("body", this.data.body);

      submit_data.append("route", this.data.route);
      submit_data.append("link_text", this.data.link);

      this.axios({
        method: "POST",
        url: "subscription",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("sendSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/subscribe/show" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.repeater_wrapper {
  // border: 1px solid #29398C;
  border-radius: 15px;
  padding-block: 20px;
  column-gap: 10px;

  h3,
  h5 {
    color: #29398c;
  }

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
